/* global document */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import * as Sentry from '@sentry/browser';

import configureStore from './store';
import './index.scss';

Sentry.init({
    dsn: "https://284caa945ed4444ab3d3dfe27e091346@sentry.io/1442200"
});

const store = configureStore();

const rootElement = document.getElementById('root');

const Root = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

render(<Root />, rootElement);
